<div class="origin-section" *ngIf="originsBarra!=null && showOrigins">
    <div class="itemBarra" *ngFor="let item of originsBarra | sortBy:'-score'"
        [ngClass]="{'selected':item.portAddressId==selectedOriginId}" (click)="selectScreenOrigin(item)">
        <div class="origin boleta" [ngStyle]="item.style" matTooltip="{{getOriginToolTip(item)}}">
            <div class="inner-boleta">
                <div class="skin">
                    <div class="country">{{item.country}}</div>
                    <div class="port">{{item.port}}</div>
                </div>
                <div class="score">{{item.score}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="originsAddicionals>0" class="origin boleta menuMes" [ngClass]="{'selected':seleccionatMenuMesOrigin}"
        (click)="obrirMenuOrigins()">
        <div class="inner-boleta">
            +{{data.originListCount}}
        </div>
    </div>
    <div *ngIf="menuOriginsObert" class="menuAddicional">
        <div class="itemMenu" *ngFor="let item of originsMenu | filter:searchTextOrigin:'skin' | slice:0:sliceCount"
            [ngClass]="{'selected':item.portAddressId==selectedOriginId}" (click)="selectScreenOrigin(item)">
            <div class="origin boleta" [ngStyle]="item.style" matTooltip="{{getOriginToolTip(item)}}">
                <div class="inner-boleta">
                    <div class="skin">
                        <div class="country">{{item.country}}</div>
                        <div class="port">{{item.port}}</div>
                    </div>
                    <div class="score">{{item.score}}</div>
                </div>
            </div>
        </div>
        <input class="searchbox" *ngIf="originsAddicionals>sliceCount" placeholder="{{'SEARCH'| translate}}" type=text
            [(ngModel)]="searchTextOrigin">

    </div>
</div>
<div class="destination-section" *ngIf="showDestinations">
    <ng-container *ngIf="destinationBarra!=null">
        <div class="itemBarra" *ngFor="let item of destinationBarra | sortBy:'-score'"
            [ngClass]="{'selected':item.portAddressId==selectedDestinationId}" (click)="selectScreenDestination(item)">
            <div class="destination boleta" [ngStyle]="item.style" matTooltip="{{getDestinationsToolTip(item)}}">
                <div class="inner-boleta">
                    <div class="skin">
                        <div class="country">{{item.country}}</div>
                        <div class="port">{{item.port}}</div>
                    </div>
                    <div class="score">{{item.score}}</div>
                </div>
            </div>
        </div>
        <div *ngIf="destinationAddicionals>0" class="destination boleta menuMes"
            [ngClass]="{'selected':seleccionatMenuMesDestinations}" (click)="obrirMenuDestinations()">
            <div class="inner-boleta">
                +{{data.destinationListCount}}
            </div>
        </div>
        <div *ngIf="menuDestinationsObert" class="menuAddicional">
            <div class="itemMenu"
                *ngFor="let item of destinationMenu | filter:searchTextDestination:'skin' | slice:0:sliceCount"
                [ngClass]="{'selected':item.portAddressId==selectedDestinationId}"
                (click)="selectScreenDestination(item)">
                <div class="destination boleta" [ngStyle]="item.style" matTooltip="{{getDestinationsToolTip(item)}}">
                    <div class="inner-boleta">
                        <div class="skin">
                            <div class="country">{{item.country}}</div>
                            <div class="port">{{item.port}}</div>
                        </div>
                        <div class="score">{{item.score}}</div>
                    </div>
                </div>
            </div>
            <input class="searchbox" *ngIf="destinationAddicionals>sliceCount" placeholder="{{'SEARCH'| translate}}"
                type=text [(ngModel)]="searchTextDestination">
        </div>
    </ng-container>
</div>